import React from 'react';
import './JobInterest.scss';
import { Collapse, Spin, Skeleton, Tag, Icon } from 'antd';
import { useEffect, useState } from 'react';
import { isMobile } from "react-device-detect";
// import parse from 'html-react-parser';
import { JobInterestForm } from './forms/JobInterest.form';
import { PRE_SHORTLIST_SOURCES } from './job-preshorlisted-developers/job-preshortlist-developers.types';
import { LLMJobTag } from '../../legacy_components/UI_V2_Components/jobsPortal/components/JobTags';
import ReadMore from './ReadMore';
import { convertTimezoneClosure, toAmPM } from '../../services/util/timezone';
import {customQuestionInputTypes} from "./forms/CustomQuestionField";
import {MONTHLY_HOURS_OF_WORK} from "../../services/util/currency";
// import { logPublicEndpointsOnlyActivity } from '../../app/user-activity-trail/user-activity-trail.actions';
// import { ActivityTypes } from './user-activity-trail/user-activity-trail.types';
// import { useQuery } from '../../hooks/use-query';

const { Panel } = Collapse;

// const { KEY, ACTIONS } = ActivityTypes.ICF;

export function JobInterest({
  getJobInterestInfo,
  getJobInfo,
  getDeveloperAvailability,
  saveAvailabilityInformation,
  getDeveloperRateDetails,
  jobInterest,
  isJobInterestDetailsFetching,
  jobInfo,
  developerRateDetails,
  developerAvailability,
  saveJobInterestInfo,
  getDeveloperInfoByJobInterestHash,
  developerInfo,
  getNotInterestedReasons,
  isNotInterestedReasonsFetching,
  notInterestedReasons,
  setDeveloperAvailability,
  setDeveloperExpectedRateDetails,
  saveRateChangeAttempt,
  timezones,
  getTimezones,
  jobs,
  hash,
  jobId,
  preview = false,
  blockSubmissionReason,
}) {
  // const query = useQuery();
  const [matchingJob, setMatchingJob] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const jobMatchingVetsmithFlag = true;
  const enableAutoShortlistVetsmithFlow = true;
  const customerWorkHoursStart = '08:00';
  const customerWorkHoursEnd = '17:00';

  const cleanupExpiredFormData = () => {
    const expiryTime = 3 * 24 * 60 * 60 * 1000;
    const keysToRemove = [];

    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key.startsWith('icf_form_')) {
        const savedData = localStorage.getItem(key);
        if (savedData) {
          const { timestamp } = JSON.parse(savedData);
          const isExpired = Date.now() - timestamp > expiryTime;
          if (isExpired) {
            keysToRemove.push(key);
          }
        }
      }
    }

    keysToRemove.forEach((key) => {
      localStorage.removeItem(key);
    });
  };

  useEffect(() => {
    cleanupExpiredFormData();
  }, []);

  useEffect(() => {
    if (Object.keys(jobInterest).length !== 0 && hash === jobInterest.idHash) {
      let vetsmithIsNotcompletedAndThereisLink =
        !jobInterest.vetsmithSatus && jobInterest.vetsmithFlowLink !== null;
      if (
        jobInterest && jobInterest.preshortlistSource === PRE_SHORTLIST_SOURCES.AUTO_SHORTLIST &&
        !enableAutoShortlistVetsmithFlow
      ) {
        vetsmithIsNotcompletedAndThereisLink = false;
      }

      const devIsInterested = jobInterest.isInterested;
      const icfIsSubmitted = jobInterest.submittedAt;
    
      if (
        !preview &&
        vetsmithIsNotcompletedAndThereisLink &&
        devIsInterested &&
        icfIsSubmitted
      ) {
        const vetsmithSubscribeLink = new URL(jobInterest.vetsmithFlowLink);
        vetsmithSubscribeLink.searchParams.append('source', 'icf');
        window.location.href = jobInterest.vetsmithFlowLink;
      }
    }

    const {  idHash = null, } = jobInterest || {};

    const matchingJob = jobs.find(job => job.jobRequestCode === idHash || job.id === jobId);
    setMatchingJob(matchingJob)
  }, [jobInterest]);

  useEffect(() => {
    getNotInterestedReasons();
    if (hash) {
      getJobInterestInfo(hash);
      getJobInfo(hash);
      getDeveloperInfoByJobInterestHash(hash);
      getDeveloperAvailability(hash);
      getDeveloperRateDetails(hash);
      getTimezones();
    }
  }, []);

  if (!hash) return;

  const isMobileDevice = window.innerWidth < 1280 || isMobile;

  const refetchDeveloperAvailability = () => {
    getDeveloperAvailability(hash);
  };

  const renderConvertedDeveloperWorkHours = (values) => {
    const developerUtcTimezone = timezones.find((tz) => tz.id === values.developerTimezoneId);
    if (!developerUtcTimezone) {
      if (developerInfo.workingHours) {
        return `${toAmPM(developerInfo.workingHours.timeFrom)} to ${toAmPM(
          developerInfo.workingHours.timeTo,
        )} PST/PDT`;
      }
      return null;
    }

    const fromCustomerToDeveloperTime = convertTimezoneClosure(
      values.jobTimezone.name,
      developerUtcTimezone.name,
    );
    return `${fromCustomerToDeveloperTime(customerWorkHoursStart)} to ${fromCustomerToDeveloperTime(
      customerWorkHoursEnd,
    )} ${developerUtcTimezone.popularName || developerUtcTimezone.name || ''}`;
  };

  const onFormSubmit = async (values$1) => {
    const submittedRate =
      values$1.newDesiredSalaryHourly || values$1.devJobRateHourly || values$1.devNteHourlyRate || values$1.devRateChangeAttemptValue;

    const values = {
      ...values$1,
      availability: {
        ...(values$1.availability || {}),
      },
      idHash: hash,
      timezoneConfirmed: values$1.isInterested,
      jobMatchingVetsmithFlag,
      availabilityAnswer: developerAvailability.availabilityAnswer,
      availabilityLength: developerAvailability.availabilityTypeId,
      noticePeriod: developerAvailability.noticePeriod,
      submittedRate,
      jobId: jobInfo.id,
    };

    if (values.isInterested && values$1.advancedConfiguration) {
      const noticePeriod = (values$1.customQuestionAnswerJson || []).find(question => question.inputType === customQuestionInputTypes.NOTICE_PERIOD);
      values.noticePeriod = +noticePeriod?.answer || 0;
      values.availabilityLength = 'fulltime';
      values.availabilityAnswer = 'ready-to-interview';

      values.availability.noticePeriod = values.noticePeriod;
      values.availability.availabilityTypeId = values.availabilityLength;
      values.availability.availabilityAnswer = values.availabilityAnswer;

      const expectedAnnualSalary = (values$1.customQuestionAnswerJson || []).find(question => question.inputType === customQuestionInputTypes.EXPECTED_ANNUAL_SALARY);
      values.newDesiredSalaryMonthly = (+expectedAnnualSalary?.answer || 0) / jobInfo.country.rate / 12;
      values.newDesiredSalaryHourly = values.newDesiredSalaryMonthly / MONTHLY_HOURS_OF_WORK;
      values.devRateChangeAttemptValue = values.newDesiredSalaryHourly;
      values.salaryConfirmed = true;
    }

    if (values && Object.keys(values.availability).length !== 0 && values.isInterested) {
      saveAvailabilityInformation(values.idHash, values.availability);
    }
    saveJobInterestInfo(values);
  };

  const isFetchingFormDetails = isJobInterestDetailsFetching || isNotInterestedReasonsFetching;
  let allowVetsmithFlow = !jobInterest.vetsmithSatus && jobInterest.vetsmithFlowLink !== null;
  if (
    jobInterest && jobInterest.preshortlistSource === PRE_SHORTLIST_SOURCES.AUTO_SHORTLIST &&
    !enableAutoShortlistVetsmithFlow
  ) {
    allowVetsmithFlow = false;
  }

  if (!developerInfo || !jobInfo || !jobInterest) return null;

  if(isFetchingFormDetails)  return (
    <div className="job-interest-form__spin-container">
      <Skeleton active paragraph={{
        rows: 6
      }} />
    </div>
  )

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const customExpandIcon = ({ isActive }) => (
    <Icon type={isActive ? "up" : "down"} />
  );

  const renderLanguages = () => {
    if (!jobInfo || !jobInfo.jobLanguages || !jobInfo.jobLanguages.length)
      return null;

    return (
      <div className="skills">
        <span className="skills-title">Required Languages : </span>
        {jobInfo.jobLanguages.map((jobLanguage) => (
          <Tag key={jobLanguage.language.id}>{jobLanguage.language.name}</Tag>
        ))}
      </div>
    );
  };


  return (
    <div className="job-interest-container">
      {/* <div className="logo-container">
        <img src="/assets/images/turing.svg" alt="Turing Logo" />
      </div> */}

      <div className="job-interest-container__body">
        <div className="job-interest-job-description">
          {/* {developerInfo.fullName ? (
            <div className="job-interest-greeting">
              <b>{developerInfo.fullName},</b> we have an exciting job opportunity for you!
            </div>
          ) : null} */}
          <Collapse
            // eslint-disable-next-line react/no-unstable-nested-components
            expandIconPosition="right"
            bordered={false}
            collapsible="header"
            expandIcon={customExpandIcon}
            defaultActiveKey={isMobileDevice && !isExpanded ? [] : ['1']}
            onChange={() => toggleExpand()}
          >
            <Panel
              showArrow
              header={
                <div className="job-interest-job-description__heading">
                  {/* <span>Job Opportunity</span> */}
                  <div className="job-interest-job-description__heading__container" data-length={(jobInfo.publicTitle && jobInfo.publicTitle.length > 20) ? 'long' : ''}>
                    <span>{jobInfo.publicTitle}</span>
                    {(matchingJob || {}).featuredJob && <LLMJobTag text={"Actively Hiring"} tooltipText={"Applying to this makes you eligible for multiple jobs."}/>}
                  </div>
                  {matchingJob && <div className="skills">
                      <span className="skills-title">Required Skills : </span>
                      {matchingJob.skills.map((skill) => <Tag key={skill.skillId}>{ skill.skillName }</Tag>)}
                  </div>}
                  {renderLanguages()}
                  {isMobileDevice && <ReadMore
                    text={jobInfo.publicDescription}
                    maxLength={100}
                    isExpanded={isExpanded}
                    onToggle={toggleExpand} 
                   />}
                </div>
              }
              key="1"
            >
              {jobInfo.publicDescription && (
                <div className="job-interest-job-description__body"
                dangerouslySetInnerHTML={{
                  __html: jobInfo.publicDescription,
                }}>
                  {/* {parse(jobInfo.publicDescription)} */}
                </div>
              )}
            </Panel>
          </Collapse>
        </div>
        <div className="job-interest-form">
          {isFetchingFormDetails ? (
            <div className="job-interest-form__spin-container">
              <Spin size="middle" />
            </div>
          ) : (
            <JobInterestForm
              onSubmit={onFormSubmit}
              jobInterest={jobInterest || {}}
              developerInfo={developerInfo}
              developerAvailability={developerAvailability}
              developerRateDetails={developerRateDetails}
              notInterestedReasons={notInterestedReasons}
              setDeveloperAvailability={setDeveloperAvailability}
              setDeveloperExpectedRateDetails={setDeveloperExpectedRateDetails}
              onDeveloperAvailabilityChange={refetchDeveloperAvailability}
              onDeveloperExpectedRateChange={setDeveloperExpectedRateDetails}
              saveRateChangeAttempt={saveRateChangeAttempt}
              createdByEmail={jobInterest.createdByEmail}
              timezones={timezones}
              isVetsmithFlow={allowVetsmithFlow}
              jobMatchingVetsmithFlag={jobMatchingVetsmithFlag}
              jobInfo={jobInfo}
              blockSubmissionReason={blockSubmissionReason}
            />
          )}
        </div>
      </div>
    </div>
  );
}
